import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  manualCoupons: [],
  autoCoupons: [],
  defaultCoupons: [],
  mergedCoupons: [],
  incentiveCoupon: false,
  upgradeCoupons: null,
  upgradePaymentPreview: null,
  appliedCoupons: false,
}

const couponSlice = createSlice({
  name: 'ccCouponState',
  initialState,
  reducers: {
    setManualCoupons(state, action) {
      state.manualCoupons = action.payload
    },
    setAutoCoupons(state, action) {
      state.autoCoupons = action.payload
    },
    clearAutoCoupons(state) {
      state.autoCoupons = []
    },
    setDefaultCoupons(state, action) {
      state.defaultCoupons = action.payload
    },
    setMergedCoupons(state, action) {
      state.mergedCoupons = action.payload
    },
    setIncentiveCoupon(state, action) {
      state.incentiveCoupon = action.payload
    },
    setUpgradeCoupons(state, action) {
      state.upgradeCoupons = action.payload
    },
    setUpgradePaymentPreview(state, action) {
      state.upgradePaymentPreview = action.payload
    },
    setAppliedCouponsFlag(state, action) {
      state.appliedCoupons = action.payload
    },
    resetAllCouponState() {
      return initialState
    },
  },
})

export const {
  setManualCoupons,
  setAutoCoupons,
  clearAutoCoupons,
  setDefaultCoupons,
  setMergedCoupons,
  setIncentiveCoupon,
  setUpgradeCoupons,
  setUpgradePaymentPreview,
  setAppliedCouponsFlag,
  resetAllCouponState,
} = couponSlice.actions

export default couponSlice.reducer
